import { useMemo } from "react";
import { normalizeFooterData, normalizeMenuData } from "@wf/ui-kit"
import { DEFAULT_LANGUAGE, ENV_NAME } from "../../../constants";
import { localeToCode } from "../../../helpers";
import bdUatLayout from "../bdUatLayout.json";
import bdStgLayout from "../bdStgLayout.json";
import bdTrnLayout from "../bdTrnLayout.json";
import bdProdLayout from "../bdProdLayout.json";

type TLanguageItem = { name: string, displayName: string }

const useLayout = (lng: string, translate: (s: string) => string) => {
  const layoutLng = lng || DEFAULT_LANGUAGE;
  let layouts = bdUatLayout;
  if (ENV_NAME === "trn") {
    // @ts-ignore
    layouts = bdTrnLayout;
  } else if (ENV_NAME === "stg") {
    // @ts-ignore
    layouts = bdStgLayout;
  } else if (ENV_NAME === "prod") {
    // @ts-ignore
    layouts = bdProdLayout;
  }


  return useMemo(() => {
    const languages: TLanguageItem[] = [];
    layouts.forEach(layout => {
      const { locale } = layout;
      const languageCode = localeToCode(locale.language_code);
      languages.push({ name: languageCode, displayName: languageCode });
    });

    const layout = layouts.find(l => localeToCode(l.locale.language_code) === layoutLng)!;

    const {
      attributes: { footer, menu, theme }
    } = layout;

    return {
      languages,
      layoutLng,
      theme: { colors: theme.colors },
      logos: theme?.logos,
      footerMenu: normalizeFooterData(footer, translate),
      menu: normalizeMenuData(menu),
    };
  }, [layouts, layoutLng, translate]);
};

export default useLayout;
